export default "__VITE_ASSET__duVRkXTO__"